"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ColorRotater = require("./ColorRotater");
Object.keys(_ColorRotater).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ColorRotater[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ColorRotater[key];
    }
  });
});